export default __webpack_public_path__ + "static/media/Kumar Elastics.4998b329.jpg";